import TableActServidoresPlanHE from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TableActServidoresPlanHE';
import TableModalActServidoresPlanHE from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TableModalActServidoresPlanHE';
import { ActivadesRegimenHEDTO, DataActividadSave, DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacionHE, ParamsHorasMesPlanificacionHEDTO, RegimenLaboralHEDTO, ServidorSeleccionado } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE';
import React, { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, Row, Col, FormGroup, Label, Input } from 'reactstrap';
import SelectItem2 from '../SelectNew';
import Swal from 'sweetalert2'

import WErrorSVG from "./../../../assets/icons/HorasExtras/Informativa R.svg"
import WarningSVG from "./../../../assets/icons/HorasExtras/Informativa N.svg"
import { ObtenerActividadesByRegimenHE } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/FunctionsPlanificacionHE';
import { alertService } from '../alert_service';
import { UnidadesData } from 'components/FetchUnidad';
import { DetalleServidoresProyHEDTO, isModificacion, isPlanificacion, isProyeccion } from 'components/DirectivoUnidad/Horas Extras/ProyeccionHE/TypesProyeccionDirectivo';
import { DetalleParametrosProyeccionHE, DetalleParametrosRegimenProyeccionHE } from 'components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras';
import { CardGroup } from 'react-bootstrap';
import { DetalleServidoresModificacionHE } from 'components/DirectivoUnidad/Horas Extras/Modificación Presupuesto Unidad/TypesModificacion';

type Props = {
    isOpen: boolean;
    toggle: () => void;
    servidoresPlan: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[];
    data: DataActividadSave | undefined;
    regimenSeleccionado: number;
    handleSubmit: (data: DataActividadSave, nombreActividad: string) => void;
    selectedServidoresAnt: { [key: number]: ServidorSeleccionado };
    regimenLaborales: RegimenLaboralHEDTO[];
    gruposActividad: DetalleGrupoActividadHEDTO[];
    isCrear: boolean;
    paramsHorasMesPlanificacionHE: ParamsHorasMesPlanificacionHEDTO[] | DetalleParametrosRegimenProyeccionHE[],
    regimenLaboralesPlan: DetalleRegimenLaboralHEDTO[];
    actividadesProyectadasPlanificadas: number[],
    tipo: "PR" | "PL" | "MD",
    idEstructura: number,
    mesesPlanifMod?: number
};

const ModalAsignarServidoresPlanHE: React.FC<Props> = ({
    isOpen,
    toggle,
    servidoresPlan,
    data,
    regimenLaborales,
    regimenLaboralesPlan,
    isCrear,
    paramsHorasMesPlanificacionHE,
    gruposActividad,
    actividadesProyectadasPlanificadas,
    handleSubmit,
    tipo,
    idEstructura,
    mesesPlanifMod
}) => {


    const defaultParametrosPlanificacion: ParamsHorasMesPlanificacionHEDTO = {
        idheparamhorasmes: 0,
        idregimenlaboral: 0,
        horasExtraordinarias: 0,
        horasSuplementarias: 0,
        horasExtraySuple: 0
    };


    const [actividadesRegimen, setActividadesRegimen] = useState<ActivadesRegimenHEDTO[]>([]);
    const [parametrosPlanificacion, setParametrosPlanificacion] = useState<ParamsHorasMesPlanificacionHEDTO>(defaultParametrosPlanificacion);
    const [regimenLaboralSeleccionado, setRegimenLaboralSeleccionado] = useState<number>(0);
    const [grupoSeleccionado, setGrupoSeleccionado] = useState<number>(0);
    const [actividadSeleccionada, setActividadSeleccionada] = useState<number>(0);
    const [horasSuplementarias, setHorasSuplementarias] = useState<number | undefined>(0);
    const [horasExtraordinarias, setHorasExtraordinarias] = useState<number | undefined>(0);
    const [observacion, setObservacion] = useState<string>('');
    const [selectedServidores, setSelectedServidores] = useState<{ [key: number]: ServidorSeleccionado }>({});
    const [initialSelectedServidores, setInitialSelectedServidores] = useState<{ [key: number]: ServidorSeleccionado }>({});

    const [error, setError] = useState<boolean>(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [cargosFiltrados, setCargosFiltrados] = useState<string[]>([]);
    const [cargoSeleccionado, setCargoSeleccionado] = useState<string>('');


    const [servidoresFiltrados, setServidoresFiltrados] = useState<DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]>([]);

    const handleBudgetExceed = (isExceeded: boolean) => {
        setIsButtonDisabled(isExceeded);
    };
    useEffect(() => {
        if (data) {
            setRegimenLaboralSeleccionado(data.regimenLaboralSeleccionado);
            setActividadSeleccionada(data.actividadSeleccionada);
            setHorasSuplementarias(data.horasSuplementarias);
            setHorasExtraordinarias(data.horasExtraordinarias);
            //setObservacion(data.observacion);
            setSelectedServidores(
                data.servidoresSeleccionados.reduce((acc, servidor) => {
                    acc[servidor.key] = servidor.value;
                    return acc;
                }, {} as { [key: number]: ServidorSeleccionado })
            );
            setInitialSelectedServidores(
                data.servidoresSeleccionados.reduce((acc, servidor) => {
                    acc[servidor.key] = servidor.value;
                    return acc;
                }, {} as { [key: number]: ServidorSeleccionado })
            )
            setGrupoSeleccionado(data.grupoSeleccionado ?? 0)
        }
    }, [data]);

    async function showAlertWarning(message, imageSrc, isError) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isError ? "Error" : "Warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerActividadesByRegimen(idRegimenLaboral: number) {
        const informacionGeneral = await ObtenerActividadesByRegimenHE(idRegimenLaboral);
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {
            setActividadesRegimen(informacionGeneral.dataResponse)
        }
        else {
            alertService.error(informacionGeneral.errorMessage);
        }
    }

    useEffect(() => {
        ObtenerActividadesByRegimen(regimenLaboralSeleccionado)
    }, [regimenLaboralSeleccionado])

    type TipoParametros = DetalleParametrosRegimenProyeccionHE | ParamsHorasMesPlanificacionHEDTO

    function isParametroRegimenProyeccion(parametro: TipoParametros): parametro is DetalleParametrosRegimenProyeccionHE {
        return (parametro as DetalleParametrosRegimenProyeccionHE).horasextraordinarias !== undefined;
    }

    function isParametroRegimenPlnificacion(parametro: TipoParametros): parametro is ParamsHorasMesPlanificacionHEDTO {
        return (parametro as ParamsHorasMesPlanificacionHEDTO).idheparamhorasmes !== undefined;
    }

    useEffect(() => {


        if (paramsHorasMesPlanificacionHE && paramsHorasMesPlanificacionHE.length > 0) {

            let parametros: TipoParametros | undefined = undefined;


            if (isParametroRegimenProyeccion(paramsHorasMesPlanificacionHE[0])) {
                parametros = (paramsHorasMesPlanificacionHE as DetalleParametrosRegimenProyeccionHE[]).find(param => param.idregimenlaboral === regimenLaboralSeleccionado);
            }
            else if (isParametroRegimenPlnificacion(paramsHorasMesPlanificacionHE[0])) {
                parametros = (paramsHorasMesPlanificacionHE as ParamsHorasMesPlanificacionHEDTO[]).find(param => param.idregimenlaboral === regimenLaboralSeleccionado);

            }
            if (parametros) {
                var nuevo: ParamsHorasMesPlanificacionHEDTO = defaultParametrosPlanificacion;
                if (isParametroRegimenPlnificacion(parametros)) {
                    nuevo = parametros
                }
                if (isParametroRegimenProyeccion(parametros)) {
                    nuevo = {
                        idheparamhorasmes: 0,
                        horasExtraordinarias: parametros.horasextraordinarias ?? 0,
                        horasSuplementarias: parametros.horassuplementarias ?? 0,
                        horasExtraySuple: parametros.horassuplyextr ?? 0,
                        idregimenlaboral: parametros.idregimenlaboral
                    }
                }
                setParametrosPlanificacion(nuevo);
            }
            else {
                setParametrosPlanificacion(defaultParametrosPlanificacion);
            }
        }
        else {
            setParametrosPlanificacion(defaultParametrosPlanificacion);
        }
    }, [regimenLaboralSeleccionado, paramsHorasMesPlanificacionHE]);



    const handleSelectionChange = (newSelection) => {
        setSelectedServidores(newSelection);
    };

    const handleAccept = () => {

        const actividad = (actividadesRegimen.find(act => act.idActividad == actividadSeleccionada))
        const nombreActividad = actividad ? actividad.nombreActividad : '';
        const dataActividadSave: DataActividadSave = {
            regimenLaboralSeleccionado: regimenLaboralSeleccionado,
            actividadSeleccionada,
            horasSuplementarias,
            horasExtraordinarias,
            observacion,
            servidoresSeleccionados: Object.entries(selectedServidores).reduce((acc, [key, value]) => {
                if (value) acc.push({ key: parseInt(key), value });
                return acc;
            }, [] as Array<{ key: number, value: ServidorSeleccionado }>)
        };

        handleSubmit(dataActividadSave, nombreActividad);
        //toggle();
    };


    const handleChange = (setter: Dispatch<SetStateAction<string>>) => (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setter(upperCaseValue);
    };

    const handleChangeNumber = (setter: Dispatch<SetStateAction<number | undefined>>) => (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setter(Number(e.target.value));
    };


    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>) => (value: string | number) => {
        setter(Number(value));
    };

    const handleChangeSelectString = (setter: Dispatch<SetStateAction<string>>) => (value: string) => {
        setter(value);
    };

    const handleBlurHorasSuplementarias = () => {
        if (tipo === "MD" && mesesPlanifMod) {
            if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasSuplementarias !== undefined && parametrosPlanificacion.horasSuplementarias !== 0 && parametrosPlanificacion.horasExtraySuple === 0 && horasSuplementarias > (mesesPlanifMod * parametrosPlanificacion.horasSuplementarias)) {
                showAlertWarning(`Sólo puede planificar hasta ${parametrosPlanificacion.horasSuplementarias} horas suplementarias por servidor, por cada mes.`, WErrorSVG, true);
                setError(true)
            } else if ((horasSuplementarias !== 0 || horasExtraordinarias !== 0) && parametrosPlanificacion.horasExtraySuple !== 0) {
                const totalHoras = (horasSuplementarias || 0) + (horasExtraordinarias || 0);

                if (totalHoras > (mesesPlanifMod * parametrosPlanificacion.horasExtraySuple)) {
                    showAlertWarning(`El total de horas suplementarias y extraordinarias no puede exceder de ${parametrosPlanificacion.horasExtraySuple} horas por servidor, por cada mes.`, WErrorSVG, true);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                setError(false)
            }
        }
        else {
            if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasSuplementarias !== undefined && parametrosPlanificacion.horasSuplementarias !== 0 && parametrosPlanificacion.horasExtraySuple === 0 && horasSuplementarias > parametrosPlanificacion.horasSuplementarias) {
                showAlertWarning(`Sólo puede planificar hasta ${parametrosPlanificacion.horasSuplementarias} horas suplementarias por servidor`, WErrorSVG, true);
                setError(true)
            } else if ((horasSuplementarias !== 0 || horasExtraordinarias !== 0) && parametrosPlanificacion.horasExtraySuple !== 0) {
                const totalHoras = (horasSuplementarias || 0) + (horasExtraordinarias || 0);

                if (totalHoras > parametrosPlanificacion.horasExtraySuple) {
                    showAlertWarning(`La suma de horas suplementarias y extraordinarias no puede exceder ${parametrosPlanificacion.horasExtraySuple} horas por servidor`, WErrorSVG, true);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                setError(false)
            }
        }
    };

    const handleBlurHorasExtraordinarias = () => {
        if (tipo === "MD" && mesesPlanifMod) {
            if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias !== undefined && parametrosPlanificacion.horasExtraordinarias !== 0 && parametrosPlanificacion.horasExtraySuple === 0 && horasExtraordinarias > (mesesPlanifMod * parametrosPlanificacion.horasExtraordinarias)) {
                showAlertWarning(`Sólo puede planificar hasta ${parametrosPlanificacion.horasExtraordinarias} horas extraordinarias por servidor, por cada mes`, WErrorSVG, true);
            } else if ((horasSuplementarias !== 0 || horasExtraordinarias !== 0) && parametrosPlanificacion.horasExtraySuple !== 0) {
                const totalHoras = (horasSuplementarias || 0) + (horasExtraordinarias || 0);
                if (totalHoras > (mesesPlanifMod * parametrosPlanificacion.horasExtraySuple)) {
                    showAlertWarning(`El total de horas suplementarias y extraordinarias no puede exceder de ${parametrosPlanificacion.horasExtraySuple} horas por servidor, por cada mes.`, WErrorSVG, true);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                setError(false)
            }
        }
        else {
            if (horasExtraordinarias === undefined && horasSuplementarias === undefined) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias === 0 && horasSuplementarias === 0) {
                showAlertWarning('Debe de ingresar el número de horas extraordinarias o de horas suplementarias', WarningSVG, true);
                setError(true)
            } else if (horasExtraordinarias !== undefined && parametrosPlanificacion.horasExtraordinarias !== 0 && parametrosPlanificacion.horasExtraySuple === 0 && horasExtraordinarias > parametrosPlanificacion.horasExtraordinarias) {
                showAlertWarning(`Sólo puede planificar hasta ${parametrosPlanificacion.horasExtraordinarias} horas extraordinarias por servidor`, WErrorSVG, true);
            } else if ((horasSuplementarias !== 0 || horasExtraordinarias !== 0) && parametrosPlanificacion.horasExtraySuple !== 0) {
                const totalHoras = (horasSuplementarias || 0) + (horasExtraordinarias || 0);
                if (totalHoras > parametrosPlanificacion.horasExtraySuple) {
                    showAlertWarning(`La suma de horas suplementarias y extraordinarias no puede exceder ${parametrosPlanificacion.horasExtraySuple} horas por servidor`, WErrorSVG, true);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                setError(false)
            }
        }
    };

    const resetFormValues = () => {
        setSelectedServidores([]);
        setRegimenLaboralSeleccionado(0);
        setActividadSeleccionada(0);
        setHorasSuplementarias(undefined);
        setHorasExtraordinarias(undefined);
        setObservacion('');
    };

    const handleCloseModal = () => {
        resetFormValues();
        toggle();
        document.body.classList.remove('modal-open');
    };



    const filteredActividades = grupoSeleccionado !== 0
        ? actividadesRegimen.filter(actividad => actividad.idGrupo === grupoSeleccionado && (!isCrear || (!actividadesProyectadasPlanificadas.includes(actividad.idActividad))))
        : actividadesRegimen.filter(actividad => !actividadesProyectadasPlanificadas.includes(actividad.idActividad));


    var tituloModal: string = isCrear ? 'Asignación de actividades a los servidores' : 'Edición de asignación de actividades a los servidores'

    if (tipo === "PR") {
        tituloModal = isCrear ? 'Asignación de actividades a los servidores para la proyección anual de horas extras' : 'Edición de asignación de actividades a los servidores para la proyección anual de horas extras'
    } else if (tipo === "MD") {
        tituloModal = isCrear ? 'Asignación de actividades para el cálculo del incremento del presupuesto de horas extras' : 'Edición de asignación de actividades a los servidores para el cálculo del incremento del presupuesto de horas extras'
    }


    useEffect(() => {
        if (regimenLaboralSeleccionado) {

            var cargosFiltradosPorRegimen: string[] = []
            
            if (servidoresPlan && servidoresPlan.length > 0) {
                if (isPlanificacion(servidoresPlan[0])) {
                    cargosFiltradosPorRegimen = (servidoresPlan as DetalleServidoresPlanificacionHE[])
                        .filter(servidor => servidor.idregimenlaboral === regimenLaboralSeleccionado)
                        .map(servidor => servidor.cargo);
                }
                else if (isProyeccion(servidoresPlan[0])) {
                    cargosFiltradosPorRegimen = (servidoresPlan as DetalleServidoresProyHEDTO[])
                        .filter(servidor => servidor.idregimenlaboral === regimenLaboralSeleccionado)
                        .map(servidor => servidor.cargo);
                }
                else if(isModificacion(servidoresPlan[0])){
                    cargosFiltradosPorRegimen = (servidoresPlan as DetalleServidoresModificacionHE[])
                        .filter(servidor => servidor.idregimenlaboral === regimenLaboralSeleccionado)
                        .map(servidor => servidor.cargo);
                }
            }
            // Eliminamos cargos duplicados si es necesario
            const cargosUnicos = [...new Set(cargosFiltradosPorRegimen)];

            setCargosFiltrados(cargosUnicos);
            setCargoSeleccionado('')
        }
    }, [regimenLaboralSeleccionado, servidoresPlan]);

    useEffect(() => {
        if (cargoSeleccionado) {

            let servidoresConCargo: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[] = []
            if (servidoresPlan && servidoresPlan.length > 0) {

                if (isPlanificacion(servidoresPlan[0])) {
                    servidoresConCargo = (servidoresPlan as DetalleServidoresPlanificacionHE[]).filter(servidor => servidor.cargo === cargoSeleccionado);
                }
                else if (isProyeccion(servidoresPlan[0])) {
                    servidoresConCargo = (servidoresPlan as DetalleServidoresProyHEDTO[]).filter(servidor => servidor.cargo === cargoSeleccionado);
                }
                else if(isModificacion(servidoresPlan[0])){
                    servidoresConCargo = (servidoresPlan as DetalleServidoresModificacionHE[]).filter(servidor => servidor.cargo === cargoSeleccionado);
                }
            }


            setServidoresFiltrados(servidoresConCargo);
        } else {
            setServidoresFiltrados(servidoresPlan); // Si no hay cargo seleccionado, mostramos todos los servidores.
        }
    }, [cargoSeleccionado, servidoresPlan]);




    const desactivarPorObservacion = tipo === "PL" && Object.values(selectedServidores).length > 0 && Object.values(selectedServidores).some(
        (servidor) => !servidor.observacion
    );


    return (
        <Modal isOpen={isOpen} size="xl">
            <ModalHeader toggle={handleCloseModal}>
                <div className='tituloModalDocumentos'>
                    {tituloModal}
                </div>
            </ModalHeader>
            <ModalBody className="modalBodyAsignarActivServ">
                <Form className="formAsignarActivServ">
                    <Row>
                        <Col lg="2" sm={6} className="alignContentend">
                            <FormGroup>
                                <Label for="regimenLaboral">Régimen Laboral*</Label>
                                <SelectItem2
                                    options={regimenLaborales.map(reg => ({ value: reg.idRegimenLaboral.toString(), label: reg.siglasRegimenLaboral.toString() }))}
                                    placeholder=""
                                    name="regimenLaboral"
                                    id="regimenLaboral"
                                    icon="fa-caret-down"
                                    value={regimenLaboralSeleccionado}
                                    onChange={handleChangeSelect(setRegimenLaboralSeleccionado)}
                                    disabled={!isCrear}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="2" sm={6} className="alignContentend">
                            <FormGroup>
                                <Label for="grupoActividad">Grupo</Label>
                                <SelectItem2
                                    options={[
                                        { value: "0", label: "SIN GRUPO" }, // Opción para seleccionar "Sin grupo"
                                        ...gruposActividad.map(reg => ({
                                            value: reg.idHeGrupoActividad.toString(),
                                            label: reg.nombreGrupo.toString()
                                        }))
                                    ]}
                                    placeholder=""
                                    name="grupoActividad"
                                    id="grupoActividad"
                                    icon="fa-caret-down"
                                    value={grupoSeleccionado}
                                    onChange={handleChangeSelect(setGrupoSeleccionado)}
                                    disabled={!isCrear}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="4" sm={12} className="alignContentend">
                            <FormGroup>
                                <Label for="actividad">Actividad*</Label>
                                <SelectItem2
                                    options={filteredActividades.map(act => ({ value: act.idActividad.toString(), label: act.nombreActividad.toString() }))}
                                    placeholder=""
                                    name="actividad"
                                    id="actividad"
                                    icon="fa-caret-down"
                                    value={actividadSeleccionada}
                                    onChange={handleChangeSelect(setActividadSeleccionada)}
                                    disabled={!isCrear}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="2" md={6} sm={4}>
                            <FormGroup>
                                <Label for="horasSuplementarias">H. Suplementarias*</Label>
                                <Input
                                    type="number"
                                    min={0}
                                    placeholder="Por Servidor"
                                    id="horasSuplementarias"
                                    name="horasSuplementarias"
                                    value={horasSuplementarias === 0 || horasSuplementarias === undefined ? '' : horasSuplementarias}
                                    onChange={handleChangeNumber(setHorasSuplementarias)}
                                    onBlur={handleBlurHorasSuplementarias}
                                    className="selectLargeText"
                                />
                                {parametrosPlanificacion.horasSuplementarias !== 0 && (
                                    <div className="text-muted small">
                                        {tipo === "MD" ? `Máx: ${parametrosPlanificacion.horasSuplementarias} horas suplementarias por mes.` : `Máx: ${parametrosPlanificacion.horasSuplementarias} horas suplementarias.`}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col lg="2" md={6} sm={4}>
                            <FormGroup>
                                <Label for="horasExtraordinarias">H. Extraordinarias*</Label>
                                <Input
                                    type="number"
                                    min={0}
                                    placeholder="Por Servidor"
                                    id="horasExtraordinarias"
                                    name="horasExtraordinarias"
                                    value={horasExtraordinarias === 0 || horasExtraordinarias === undefined ? '' : horasExtraordinarias}
                                    onChange={handleChangeNumber(setHorasExtraordinarias)}
                                    onBlur={handleBlurHorasExtraordinarias}
                                    className="selectLargeText"
                                />

                                {parametrosPlanificacion.horasExtraordinarias !== 0 && (
                                    <div className="text-muted small">
                                        {tipo === "MD" ? `Máx: ${parametrosPlanificacion.horasExtraordinarias} horas extraordinarias por mes.` : `Máx: ${parametrosPlanificacion.horasExtraordinarias} horas extraordinarias.`}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="0" lg={8}>
                        </Col>
                        <Col md="12" lg={4}>
                            {parametrosPlanificacion.horasExtraySuple !== 0 && (
                                <div className="text-muted small">
                                    {tipo === "MD" ? `El total de horas suplementarias y extraordinarias no debe exceder de ${parametrosPlanificacion.horasExtraySuple} horas por servidor, por mes.` : `La suma de horas suplementarias y extraordinarias no debe exceder de ${parametrosPlanificacion.horasExtraySuple} horas por servidor.`}
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label for="cargo">Cargo</Label>
                                <SelectItem2
                                    options={[
                                        { value: "", label: "SIN CARGO" }, // Opción para seleccionar "Sin grupo"
                                        ...cargosFiltrados.map(cargo => ({
                                            value: cargo,
                                            label: cargo
                                        }))
                                    ]}

                                    placeholder=""
                                    name="cargo"
                                    id="cargo"
                                    icon="fa-caret-down"
                                    value={cargoSeleccionado}
                                    onChange={handleChangeSelectString(setCargoSeleccionado)}
                                // disabled={!isCrear}
                                />

                            </FormGroup>
                        </Col>


                        {
                            //Solo si es Planificación se requiere de observación 
                            tipo === "PL" && (

                                <Col md="8">
                                    <FormGroup>
                                        <Label for="observacion">Descripción específica de la actividad*</Label>
                                        <Input
                                            type="text"
                                            placeholder="Describir la acción relacionada a la actividad seleccionada y el lugar en caso que aplique"
                                            id="observacion"
                                            name="observacion"
                                            value={observacion}
                                            onChange={handleChange(setObservacion)}
                                            className="selectLargeText"
                                            disabled={!isCrear}
                                        />

                                    </FormGroup>
                                </Col>
                            )
                        }
                    </Row>
                </Form>
                {tipo === "MD" && (
                    <TableModalActServidoresPlanHE
                        servidoresPlan={servidoresFiltrados}
                        selectedServidoresAnt={selectedServidores}
                        initialSelectedServidores={initialSelectedServidores }
                        regimenSeleccionado={regimenLaboralSeleccionado}
                        regimenLaboralesPlan={regimenLaboralesPlan}
                        horasExtraordinarias={horasExtraordinarias}
                        horasSuplementarias={horasSuplementarias}
                        maxHorasExtraordinarias={parametrosPlanificacion.horasExtraordinarias}
                        maxHorasSuplementarias={parametrosPlanificacion.horasSuplementarias}
                        maxHorasExtraySuple={parametrosPlanificacion.horasExtraySuple}
                        onSelectionChange={handleSelectionChange}
                        isCrear={isCrear}
                        rowsPerPage={30}
                        onBudgetExceed={handleBudgetExceed}
                        idEstructura={idEstructura}
                        idActividad={actividadSeleccionada}
                        factorMesesPlan={mesesPlanifMod}
                        tipo='MD'
                    />
                )}
                {!(tipo === "MD") && (
                    <TableModalActServidoresPlanHE
                        servidoresPlan={servidoresFiltrados}
                        selectedServidoresAnt={selectedServidores}
                        initialSelectedServidores={initialSelectedServidores}
                        regimenSeleccionado={regimenLaboralSeleccionado}
                        regimenLaboralesPlan={regimenLaboralesPlan}
                        horasExtraordinarias={horasExtraordinarias}
                        horasSuplementarias={horasSuplementarias}
                        maxHorasExtraordinarias={parametrosPlanificacion.horasExtraordinarias}
                        maxHorasSuplementarias={parametrosPlanificacion.horasSuplementarias}
                        maxHorasExtraySuple={parametrosPlanificacion.horasExtraySuple}
                        onSelectionChange={handleSelectionChange}
                        isCrear={isCrear}
                        rowsPerPage={30}
                        onBudgetExceed={handleBudgetExceed}
                        idEstructura={idEstructura}
                        idActividad={actividadSeleccionada}
                        observacion={observacion}
                        tipo={tipo}
                    />
                )}
            </ModalBody>
            <ModalFooter className="modal-footer-planificacion">
                <Row className="justify-content-center">
                    <Col lg={6} sm={6} className="d-flex justify-content-center">
                        <Button className="btn-cancelar" onClick={handleCloseModal}>Cancelar</Button>
                    </Col>
                    <Col lg={6} sm={6} className="d-flex justify-content-center">
                        <Button
                            className="btn-aceptar"
                            onClick={() => { handleAccept(); }}
                            disabled={error || desactivarPorObservacion || actividadSeleccionada === 0 || (Array.isArray(selectedServidores) ? selectedServidores.length === 0 : Object.keys(selectedServidores).length === 0 || isButtonDisabled)}
                        >
                            Aceptar
                        </Button>
                    </Col>
                </Row>

            </ModalFooter>
        </Modal>
    );
};

export default ModalAsignarServidoresPlanHE;